module.exports = __webpack_public_path__ + "static/getStarted-cf625f6a17a1b9e29b6d5539ab70c3d4.png";